import useStore from "hooks/useStore";
import styled from "styled-components";
import WriteAnswerComment from "./WriteAnswerComment";
import CommentItem from "./CommentItem";

interface Props {
  data: any;
}

const Comment = ({ data }: Props) => {
  const { user } = useStore();

  return (
    <CommentContainer>
      {data
        ?.filter((d: any) => d.isApproved)
        ?.sort(
          (a: any, b: any) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        )
        ?.map((comment: any, indx: number) => {
          return (
            <CommentInnerContainer key={indx}>
              <CommentItem comment={comment} />
              {user?.id && (
                <WriteAnswerComment
                  campId={comment?.campId}
                  parentId={comment?.id}
                />
              )}
              <CommentAnswers showBorder={comment?.children.length}>
                {comment?.children?.map((comm: any, index: number) => (
                  <CommentItem comment={comm} key={index} secondary />
                ))}
              </CommentAnswers>
            </CommentInnerContainer>
          );
        })}
    </CommentContainer>
  );
};

const CommentContainer = styled.div`
  margin-top: 32px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0px, 1fr));
  grid-gap: 40px;
  grid-column-gap: 70px;
  @media (max-width: ${(props) => props.theme.size.tablet}) {
    grid-template-columns: repeat(1, minmax(0px, 1fr));
  }
`;

const CommentInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const CommentAnswers = styled.div<{showBorder?: boolean}>`
  display; flex;
  flex-direction: column;
  margin-left: 12px;
  margin-top: 10px;
  border-left: ${(props) => props.showBorder && '1px solid #d4d4d4'}; 
`;

export default Comment;
